import request from '../utils/request.js'

/** 活动接口 */

/**
 * 全部活动
 * @param params
 * @returns {AxiosPromise}
 */
export function allAct(params) {
  return request({
    url: '/api/activity',
    method: 'get',
    params: params
  })
}

/**
 * 活动详情
 * @param params
 * @returns {AxiosPromise}
 */
export function actDetail(activityId) {
  return request({
    url: `/api/activity/${activityId}`,
    method: 'get'
  })
}

/**
 * 首单设置详情
 * @param params
 * @returns {AxiosPromise}
 */
export function firstDetail(activityId) {
  return request({
    url: `/api/activity/first_order_discount/${activityId}`,
    method: 'get'
  })
}

/**
 * 特惠活动详情
 * @param params
 * @returns {AxiosPromise}
 */
export function ticketDetail(activityId) {
  return request({
    url: `/api/activity/movie_ticket_discount/${activityId}`,
    method: 'get'
  })
}

/**
 * 删除活动
 * @param params
 * @returns {AxiosPromise}
 */
export function delAct(activityId) {
  return request({
    url: `/api/activity/${activityId}`,
    method: 'delete'
  })
}

/**
 * 保存首单特惠
 * @param params
 * @returns {AxiosPromise}
 */
export function save_first_order_discount(params) {
  return request({
    url: '/api/activity/first_order_discount',
    method: 'post',
    data: params
  })
}

/**
 * 保存特惠活动
 * @param params
 * @returns {AxiosPromise}
 */
export function save_movie_ticket_discount(params) {
  return request({
    url: '/api/activity/movie_ticket_discount',
    method: 'post',
    data: params
  })
}

/**
 * 活动已选择的分站
 * @param params
 * @returns {AxiosPromise}
 */
export function actSelStation(data) {
  return request({
    url: `/api/activity/station`,
    method: 'get',
    params: data
  })
}

/**
 * 城市集合
 * @param params
 * @returns {AxiosPromise}
 */
export function cities() {
  return request({
    url: `/api/city/list`,
    method: 'get'
  })
}

/**
 * 店铺集合
 */
export function shops(params) {
  return request({
    url: `/api/shop`,
    method: 'get',
    params: params
  })
}
//店铺品牌
export function shopBrands() {
  return request({
    url: `/api/shop/brands`,
    method: 'get'
  })
}
//保存点餐特惠
export function saveMaHua(data) {
  return request({
    url: `/api/activity/mahua_discount`,
    method: 'post',
    data: data
  })
}
//点餐特惠设置
export function saveMaHuaGet(activityId) {
  return request({
    url: `/api/activity/mahua_discount/${activityId}`,
    method: 'get'
  })
}
//本地特惠设置
export function saveLocalGet(activityId) {
  return request({
    url: `/api/activity/local_cater_discount/${activityId}`,
    method: 'get'
  })
}
/**
 * 暂停
 * @param params
 * @returns {AxiosPromise}
 */
export function pause(activityId) {
  return request({
    url: `/api/activity/pause/${activityId}`,
    method: 'get'
  })
}

/**
 * 完成
 * @param params
 * @returns {AxiosPromise}
 */
export function complete(activityId) {
  return request({
    url: `/api/activity/complete/${activityId}`,
    method: 'get'
  })
}

/**
 * 开启
 * @param params
 * @returns {AxiosPromise}
 */
export function start(activityId) {
  return request({
    url: `/api/activity/start/${activityId}`,
    method: 'get'
  })
}

/**
 * 保存h5活动
 * @param params
 * @returns {AxiosPromise}
 */
export function add_h5_coupon(params) {
  return request({
    url: '/api/activity/h5_coupon',
    method: 'post',
    data: params
  })
}

/**
 * 保存小程序活动
 * @param params
 * @returns {AxiosPromise}
 */
export function add_miniapp_coupon(params) {
  return request({
    url: '/api/activity/miniapp_coupon',
    method: 'post',
    data: params
  })
}

/**
 * 保存影院领券活动
 * @param params
 * @returns {AxiosPromise}
 */
export function add_cinema_coupon(params) {
  return request({
    url: '/api/activity/cinema_coupon',
    method: 'post',
    data: params
  })
}

/**
 * 保存点餐领券活动
 * @param params
 * @returns {AxiosPromise}
 */
export function add_mahua_coupon(params) {
  return request({
    url: '/api/activity/mahua_coupon',
    method: 'post',
    data: params
  })
}
/**
 * 参与活动的人员
 * @param params
 * @returns {AxiosPromise}
 */
export function user_activity_log(params) {
  return request({
    url: '/api/activity/user_activity_log',
    method: 'get',
    params: params
  })
}

/**
 * 追加卡券
 * @param params
 * @returns {AxiosPromise}
 */
export function put_card(params) {
  return request({
    url: '/api/activity/put_card',
    method: 'post',
    data: params
  })
}

/**
 * 保存影院券包
 * @param params
 * @returns {AxiosPromise}
 */
export function save_coupon_package(params) {
  return request({
    url: `/api/activity/coupon_package`,
    method: 'post',
    data: params
  })
}


/**
 * 推文查询
 * @param params
 * @returns {AxiosPromise}
 */
export function article(params) {
  return request({
    url: '/api/mp_article',
    method: 'get',
    params: params
  })
}

/**
 * 推文查询详情
 * @param params
 * @returns {AxiosPromise}
 */
export function articleId(articleId) {
  return request({
    url: `/api/mp_article/${articleId}`,
    method: 'get'
  })
}
/**
 * 保存文章
 * @param params
 * @returns {AxiosPromise}
 */
export function saveArticle(params) {
  return request({
    url: '/api/mp_article',
    method: 'post',
    data: params
  })
}
/**
 * 删除文章
 * @param params
 * @returns {AxiosPromise}
 */
export function articleDel(articleId) {
  return request({
    url: `/api/mp_article/${articleId}`,
    method: 'delete'
  })
}
/**
 * 推送文章
 * @param params
 * @returns {AxiosPromise}
 */
export function pushArticle(params) {
  return request({
    url: '/api/mp_article/push',
    method: 'post',
    data: params
  })
}

/**
 * 文章分类列表
 * @param params
 * @returns {AxiosPromise}
 */
export function articleCategory(params) {
  return request({
    url: '/api/article_category/list',
    method: 'get',
    params: params
  })
}
/**
 * 贴片分类列表
 * @param params
 * @returns {AxiosPromise}
 */
export function articleCategoryImage(params) {
  return request({
    url: '/api/article_category/image',
    method: 'get',
    params: params
  })
}
/**
 * 分类保存
 * @param params
 * @returns {AxiosPromise}
 */
export function saveCategory(params) {
  return request({
    url: '/api/article_category',
    method: 'post',
    data: params
  })
}
/**
 * 保存贴片
 * @param params
 * @returns {AxiosPromise}
 */
export function saveArticleImage(params) {
  return request({
    url: '/api/mp_article/image',
    method: 'post',
    data: params
  })
}
/**
 * 分类删除
 * @param params
 * @returns {AxiosPromise}
 */
export function delCategory(categoryId) {
  return request({
    url: `/api/article_category/${categoryId}`,
    method: 'delete',
  })
}
/**
 * 通知机器人查询
 * @param params
 * @returns {AxiosPromise}
 */
export function robot(params) {
  return request({
    url: `/api/notify_robot`,
    method: 'get',
    params: params
  })
}
/**
 * 通知机器人保存
 * @param params
 * @returns {AxiosPromise}
 */
export function saveRobot(params) {
  return request({
    url: `/api/notify_robot`,
    method: 'post',
    data: params
  })
}
/**
 * 通知机器人删除
 * @param params
 * @returns {AxiosPromise}
 */
export function delRobot(robotId) {
  return request({
    url: `/api/notify_robot/${robotId}`,
    method: 'delete',
  })
}

/**
 * 保存天降红包
 * @param params
 * @returns {AxiosPromise}
 */
export function saveCouponPrompt(params) {
  return request({
    url: `/api/activity/coupon_prompt`,
    method: 'post',
    data: params
  })
}
/**
 * 搜索天降红包用户
 * @param params
 * @returns {AxiosPromise}
 */
export function couponPromptUser(params) {
  return request({
    url: `/api/activity/coupon_prompt_user`,
    method: 'get',
    params: params
  })
}
/**
 * 查询天降红包用户
 * @param params
 * @returns {AxiosPromise}
 */
export function generateCouponPrompt(activityId) {
  return request({
    url: `/api/activity/generate_coupon_prompt/${activityId}`,
    method: 'get',
  })
}
/**
 * 发放天降红包用户
 * @param params
 * @returns {AxiosPromise}
 */
export function savePullCouponPrompt(params) {
  return request({
    url: `/api/activity/pull_coupon_prompt`,
    method: 'post',
    data: params
  })
}
/**
 * 导出用户
 * @param params
 * @returns {AxiosPromise}
 */
export function exportUser(activityId) {
  return request({
    url: `/api/activity/export/${activityId}`,
    method: 'get',
  })
}
/**
 * 保存本地特惠活动
 * @param params
 * @returns {AxiosPromise}
 */
export function saveLocalCaterDiscount(params) {
  return request({
    url: `/api/activity/local_cater_discount`,
    method: 'post',
    data: params
  })
}
/**
 * 保存本地生活店铺领劵活动
 * @param params
 * @returns {AxiosPromise}
 */
export function saveLocalCaterCoupon(params) {
  return request({
    url: `/api/activity/local_cater_coupon`,
    method: 'post',
    data: params
  })
}

/**
 * 文章素材
 * @param params
 * @returns {AxiosPromise}
 */
export function getArticleMedia(params) {
  return request({
    url: `/api/article_media`,
    method: 'get',
    params: params
  })
}
/**
 * 删除素材
 * @param params
 * @returns {AxiosPromise}
 */
export function getArticleMediaId(id) {
  return request({
    url: `/api/article_media/${id}`,
    method: 'get',
  })
}
/**
 * 保存文章素材
 * @param params
 * @returns {AxiosPromise}
 */
export function postArticleMedia(params) {
  return request({
    url: `/api/article_media`,
    method: 'post',
    data: params
  })
}
/**
 * 删除素材
 * @param params
 * @returns {AxiosPromise}
 */
export function delArticleMedia(id) {
  return request({
    url: `/api/article_media/${id}`,
    method: 'delete',
  })
}

/**
 * 获取替换素材
 * @param params
 * @returns {AxiosPromise}
 */
export function getReplaces(params) {
  return request({
    url: `/api/article_media/replaces`,
    method: 'get',
    params: params
  })
}
/**
 * 保存替换素材
 * @param params
 * @returns {AxiosPromise}
 */
export function postReplaces(params) {
  return request({
    url: `/api/article_media/replaces`,
    method: 'post',
    data: params
  })
}
/**
 * 获取字典数据
 * @param params
 * @returns {AxiosPromise}
 */
export function getDictList(params) {
  return request({
    url: `/api/dict/list`,
    method: 'get',
    params: params
  })
}


/**
 * 保存富文本
 * @param params
 * @returns {AxiosPromise}
 */
export function htmlEditor(params) {
  return request({
    url: '/api/html_editor',
    method: 'post',
    data: params
  })
}
/**
 * 获取富文本
 * @param params
 * @returns {AxiosPromise}
 */
export function getHtmlEditor(params) {
  return request({
    url: '/api/html_editor',
    method: 'get',
    params: params
  })
}
/**
 * 保存秒杀活动
 * @param params
 * @returns {AxiosPromise}
 */
export function postActivitySeckill(params) {
  return request({
    url: `/api/activity/seckill`,
    method: 'post',
    data: params
  })
}
/**
  * 获取微博分类
  * @param params
  * @returns {AxiosPromise}
  */
export function getWeiboList(params) {
  return request({
    url: `/api/article_category/weibo`,
    method: 'get',
    params: params
  })
}

/**
 * 保存微博推文
 * @param params
 * @returns {AxiosPromise}
 */
export function postWeibo(params) {
  return request({
    url: `/api/mp_article/weibo`,
    method: 'post',
    data: params
  })
}
/**
 * 获取报名商品
 * @param params
 * @returns {AxiosPromise}
 */
export function getSeckillGoods(params) {
  return request({
    url: '/api/activity/seckill_goods',
    method: 'get',
    params: params
  })
}
/**
 * 秒杀审核通过
 * @param params
 * @returns {AxiosPromise}
 */
export function postSeckillResolve(params) {
  return request({
    url: '/api/activity/seckill_resolve',
    method: 'post',
    data: params
  })
}

/**
 * 秒杀审核拒绝
 * @param params
 * @returns {AxiosPromise}
 */
export function postSeckillReject(params) {
  return request({
    url: '/api/activity/seckill_reject',
    method: 'post',
    data: params
  })
}

/**
 * 添加秒杀商品
 * @param params
 * @returns {AxiosPromise}
 */
export function postActivitySeckillGoods(params) {
  return request({
    url: '/api/activity/seckill_goods',
    method: 'post',
    data: params
  })
}
/**
 * 重建商品缓存
 * @param params
 * @returns {AxiosPromise}
 */
export function getRebuild() {
  return request({
    url: '/api/goods/rebuild',
    method: 'get',
  })
}

/**
 * 添加秒杀商品
 * @param params
 * @returns {AxiosPromise}
 */
export function postActivityAddMsGoods(params) {
  return request({
    url: '/api/activity/addMsGoods',
    method: 'post',
    data: params
  })
}
